import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '~services/auth/auth.service';

@Injectable()
export class AuthGuardService {
  constructor(private authService: AuthService) {}

  async canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!(await this.authService.isAuthenticated())) {
      this.authService.navigateToLoginPage(state.url);
      return false;
    }

    return true;
  }
}
